import Api from '@/services/Api'

export default {
  getLang () {
    return Api().get('print/lang')
  },
  setLang (lang) {
    return Api().post('print/lang', lang)
  },
  print (orderinfo) {
    return Api().post('print', orderinfo)
  }
}



// WEBPACK FOOTER //
// ./src/services/PrintService.js